"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("../lib");
const GraphandModelPromise_1 = __importDefault(require("../lib/GraphandModelPromise"));
const GraphandQuery_1 = __importDefault(require("../lib/GraphandQuery"));
const isId_1 = __importDefault(require("./isId"));
function getModelInstance(Model, query, fetch, cache) {
    var _a, _b;
    cache = cache !== null && cache !== void 0 ? cache : !fetch;
    fetch = fetch !== null && fetch !== void 0 ? fetch : true;
    if (!query) {
        return new GraphandModelPromise_1.default(async (resolve, reject) => {
            await Model._init();
            try {
                const { rows } = await new GraphandQuery_1.default(Model).execute();
                const _id = rows[0]._id;
                resolve(Model.get(_id, false));
            }
            catch (e) {
                reject(e);
            }
        }, Model);
    }
    let _id;
    if (query instanceof lib_1.GraphandModel || query instanceof GraphandModelPromise_1.default) {
        _id = query._id;
        query = { query: { _id } };
        cache = cache !== null && cache !== void 0 ? cache : true;
    }
    else if (typeof query === "string") {
        _id = query;
        query = { query: { _id } };
        cache = cache !== null && cache !== void 0 ? cache : true;
    }
    else if (typeof query === "object" && ((_a = query.query) === null || _a === void 0 ? void 0 : _a._id) && typeof query.query._id === "string") {
        _id = query.query._id;
        cache = cache !== null && cache !== void 0 ? cache : Object.keys(query).length === 1;
    }
    else {
        cache = cache !== null && cache !== void 0 ? cache : true;
    }
    const fetchOpts = typeof fetch === "object" ? fetch : {};
    fetchOpts.cache = (_b = fetchOpts.cache) !== null && _b !== void 0 ? _b : cache;
    let item;
    if (fetchOpts.cache && _id) {
        const modelList = Model.getList();
        item = modelList.find((item) => item._id === _id);
    }
    if (item && fetchOpts.populate) {
        // TODO : check if all populate fields are already populated
        item = null;
    }
    if (!item && fetch) {
        return new GraphandModelPromise_1.default(async (resolve, reject) => {
            await Model._init();
            try {
                const _isId = (0, isId_1.default)(_id);
                const q = _isId ? { ids: [_id] } : Object.assign(Object.assign({}, query), { pageSize: 1 });
                const { rows } = await new GraphandQuery_1.default(Model, q).execute(fetchOpts);
                const row = _isId ? rows.find((row) => row._id === _id) : rows[0];
                if (row === null || row === void 0 ? void 0 : row._id) {
                    let item;
                    if (cache) {
                        item = Model.get(row === null || row === void 0 ? void 0 : row._id, false);
                    }
                    item = item || new Model(row);
                    return resolve(item);
                }
                return resolve(null);
            }
            catch (e) {
                reject(e);
            }
        }, Model, query);
    }
    return item;
}
exports.default = getModelInstance;
